<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-课堂（课室）-添加
    -->
    <el-dialog
    title="添加课堂（课室）"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

      <el-form-item label="名称" prop="name"><el-input v-model="form.name" placeholder="请输入课堂（课室）名称" class="max-w460"></el-input></el-form-item>
<el-form-item label="组织名称" prop="orgName">
          <el-select v-model="form.orgName" placeholder="请选择组织名称" class="max-w460">
            <el-option v-for="item in organizationList" :key="item.ma_company_id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
<!-- <el-form-item label="课堂名称" prop="className"><el-input v-model="form.className" placeholder="请输入课堂名称" class="max-w460"></el-input></el-form-item> -->
<el-form-item label="课堂用途" prop="classPurpose"><el-input v-model="form.classPurpose" placeholder="请输入课堂用途" class="max-w460"></el-input></el-form-item>
<el-form-item label="可容纳人数" prop="capacity"><el-input v-model="form.capacity" placeholder="请输入可容纳人数" class="max-w460"></el-input></el-form-item>
<el-form-item label="课堂状态" prop="classStatus">
          <el-radio-group v-model="form.classStatus">
            <el-radio label="正常">正常</el-radio>
            <el-radio label="停用">停用</el-radio>
          </el-radio-group>
        </el-form-item>
<el-form-item label="开始时间" prop="startTime">
          <el-time-picker
            v-model="form.startTime"
            placeholder="请选择开始时间"
            class="max-w460"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-time-picker
            v-model="form.endTime"
            placeholder="请选择结束时间"
            class="max-w460"
          ></el-time-picker>
        </el-form-item>
<el-form-item label="适用范围" prop="applicableScope"><el-input v-model="form.applicableScope" placeholder="请输入适用范围" class="max-w460"></el-input></el-form-item>
<el-form-item label="绑定课件" prop="bound_courseware">
  <el-input v-model="form.bound_courseware" placeholder="请选择绑定课件" class="max-w460" readonly>
    <template slot="append">
      <el-button size="small" @click="openCoursewareSelect">选择</el-button>
    </template>
  </el-input>
</el-form-item>
      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>



      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--课件选择组件-->
    <GetCourseware :is_open="showCoursewareSelect" @close="closeCoursewareSelect"></GetCourseware>
     <!--业务附件上传组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
 </div>
</el-dialog>

</template>

<script>
import Ma_classrm_mgmtApi from '@/api/ma_classrm_mgmt.js';
import Ma_companyApi from '@/api/ma_company.js';
import Upload from '@/components/file/Upload';
import GetCourseware from '@/components/courseware/GetCourseware.vue';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     GetCourseware,
     draggable,
     Uediter
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:[],
        // categorya:{},
        sort:50,
        intro:"",
        bannar:[],
        bound_courseware: '',
        courseware_ids: ''
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入课堂（课室）名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      /*组织列表数据*/
      organizationList: [],
      /*是否显示课件选择弹窗*/
      showCoursewareSelect: false
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.loadOrganizations();
  },
  props: ["open_add"],
  methods: {

    chooseCategory(){
      this.iscategorya = true;
    },

    /*加载组织列表数据*/
    loadOrganizations() {
      let self = this;
      Ma_companyApi.list({}, true)
          .then(data => {
            if (data.code == 1) {
              self.organizationList = data.data.list.data;
            }
          })
          .catch(error => {
          });
    },
    /*根据公司ID获取公司名称*/
    getCompanyName(companyId) {
      if (!companyId) return '-';
      const company = this.organizationList.find(item => item.ma_company_id == companyId);
      return company ? company.name : '-';
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      //form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_classrm_mgmtApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }

      this.isProductUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }

    },
    /*打开课件选择弹窗*/
    openCoursewareSelect() {
      this.showCoursewareSelect = true;
    },
    /*关闭课件选择弹窗并回填选中*/
    closeCoursewareSelect(e) {
      if (e && e.type === 'success' && e.params && e.params.length) {
        this.form.bound_courseware = e.params.map(item => item.name).join(',');
        this.form.courseware_ids = e.params.map(item => item.courseware_id).join(',');
      }
      this.showCoursewareSelect = false;
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_classrm_mgmt/index/part/add.vue